export default [{
  path: '/reason',
  name: 'reason',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/reason/index')
}]
